import React, { useState, useEffect, useCallback } from 'react';
import { api, inviteLink } from './api';
import Icon from './Icon';

const TeamPanel = () => {
  const [team, setTeam] = useState([]);
  const [email, setEmail] = useState('');
  const [invite, setInvite] = useState(null); // { email, link }
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setTeam(await api.managers()); setError(''); }
    catch (err) { setError(err.message); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const sendInvite = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true); setCopied(false);
    try {
      const { token, email: invited } = await api.inviteManager(email);
      setInvite({ email: invited, link: inviteLink(token) });
      setEmail('');
      load();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  const copyLink = async () => {
    try { await navigator.clipboard.writeText(invite.link); setCopied(true); setTimeout(() => setCopied(false), 2000); }
    catch { /* clipboard blocked — user can select manually */ }
  };

  const remove = async (m) => {
    if (!window.confirm(`Remove ${m.email}? They will lose access immediately.`)) return;
    try { await api.removeManager(m.id); load(); }
    catch (err) { setError(err.message); }
  };

  const fmt = (d) => (d ? new Date(d).toLocaleDateString() : '—');

  return (
    <div className="team-panel">
      <div className="team-grid">
        <form className="invite-card" onSubmit={sendInvite}>
          <h3>Invite a shop manager</h3>
          <p className="admin-subtle">They’ll get a link to set their own password.</p>
          <div className="invite-row">
            <input
              type="email"
              placeholder="manager@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="admin-primary-btn" disabled={busy || !email}>
              {busy ? 'Creating…' : 'Create invite'}
            </button>
          </div>
          {error && <p className="admin-error"><Icon name="alert" size={15} /> {error}</p>}

          {invite && (
            <div className="invite-result">
              <p><Icon name="check-circle" size={15} /> Invite ready for <strong>{invite.email}</strong>. Share this link:</p>
              <div className="invite-link-box">
                <input readOnly value={invite.link} onFocus={(e) => e.target.select()} />
                <button type="button" className="admin-ghost-btn" onClick={copyLink}>
                  {copied ? <><Icon name="check" size={14} /> Copied</> : 'Copy'}
                </button>
              </div>
              <p className="admin-subtle">The link works once — until they set a password. You can re-invite to get a fresh link.</p>
            </div>
          )}
        </form>

        <div className="team-list-card">
          <h3>Team ({team.length})</h3>
          <div className="table-wrap">
            <table className="bookings-table">
              <thead><tr><th>Email</th><th>Status</th><th>Invited</th><th>Active since</th><th></th></tr></thead>
              <tbody>
                {team.map((m) => (
                  <tr key={m.id}>
                    <td className="cell-strong">{m.email}</td>
                    <td><span className={`status-badge status-${m.status === 'active' ? 'confirmed' : 'pending'}`}>{m.status}</span></td>
                    <td>{fmt(m.invited_at)}</td>
                    <td>{fmt(m.activated_at)}</td>
                    <td className="row-actions"><button className="danger" onClick={() => remove(m)}>Remove</button></td>
                  </tr>
                ))}
                {!team.length && <tr><td colSpan={5} className="empty-row">No managers yet. Invite one above.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPanel;
